import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Users FETCH mutations on CATEGORIES
  fetchCategories: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchCategories';

    commit(`${mutationPrefix}Pending`);

    return api.fetchCategories(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on CATEGORIES
  createCategory: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createCategory';

    commit(`${mutationPrefix}Pending`);

    return api.createCategory(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on CATEGORIES
  updateCategory: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateCategory';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateCategory(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on CATEGORIES
  removeCategory: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'removeCategory';

    commit(`${mutationPrefix}Pending`, id);

    return api.removeCategory(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses UPDATE mutations on CATEGORIES
  setDefaultCategory: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'setDefaultCategory';

    commit(`${mutationPrefix}Pending`, id);

    return api.setDefaultCategory(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/category/actions.js